import styles from './ErenBlaze.module.css';
import Header from "@/commons/pages/borders/header/Header";
import Footer from "@/commons/pages/borders/footer/Footer";
import React from "react";

import scritta from "@/commons/resources/images/erenblaze/scritta.png";

import eren1 from "@/commons/resources/images/erenblaze/eren1.jpg";
import eren2 from "@/commons/resources/images/erenblaze/eren2.jpg";
import eren3 from "@/commons/resources/images/erenblaze/eren3.jpg";

import yt from "@/commons/resources/icons/youtube.svg"
import tw from "@/commons/resources/icons/twitch.svg"
import email from "@/commons/resources/icons/email.svg"

import ig from "@/commons/resources/icons/instagram_colored.svg"
import tt from "@/commons/resources/icons/tiktok_colored.svg"
import ds from "@/commons/resources/icons/discord_colored.svg"
import tg from "@/commons/resources/icons/telegram_colored.svg"
import am from "@/commons/resources/icons/amazon_colored.svg"
import Redirects from "@/commons/utils/Redirects";

const ErenBlaze = () => {

    document.title = "EBLCraft - ErenBlaze"

    return (
        <>
            <div className={styles.erenblaze__body}>
                <Header/>
                <div className={styles.erenblaze__banner} />
                <img className={styles.erenblaze_bannerlogo} src={scritta} alt={"Scritta"}/>
                <div className={styles.erenblaze__content}>
                    <div className={styles.erenblaze__section}>
                        <img src={eren1} alt={"Simone Caglioni"}/>
                        <div className={styles.erenblaze__content}>
                            <h1 className={styles.erenblaze__title}>MI PRESENTO</h1>
                            <div className={styles.erenblaze__paragraph}>
                                <p>Mi chiamo Simone Caglioni, ma online sono meglio conosciuto come ErenBlaze,
                                    uno youtuber e content creator specializzato in contenuti legati al mondo dei videogiochi.
                                    Il mio canale YouTube è stato fondato nel maggio 2013 e, da allora, ho raggiunto un pubblico di
                                    oltre 827.000 iscritti e accumulato più di 484 milioni di visualizzazioni complessive.</p>
                                <p>
                                    La mia passione per il gaming e la creazione di contenuti mi ha portato a dedicare la maggior
                                    parte del mio tempo a realizzare video che spaziano da gameplay e recensioni a guide dettagliate per
                                    aiutare la mia community. Il nome "ErenBlaze" deriva dalle mie due grandi passioni: Eren,
                                    protagonista dell'anime Attack on Titan, e Blaze, una delle creature ostili di Minecraft,
                                    il gioco che ha segnato l'inizio della mia carriera su YouTube.
                                </p>
                            </div>

                        </div>
                    </div>
                    <div className={[styles.erenblaze__section, styles.erenblaze__section_inverted].join(' ')}>
                        <div className={styles.erenblaze__content}>
                            <h1 className={styles.erenblaze__title}>LA MIA STORIA</h1>
                            <div className={styles.erenblaze__paragraph}>
                                <p>Tutto è iniziato con la passione per i videogiochi e per il web. Da lì è
                                    arrivata la voglia di condividere le mie esperienze online cominciando
                                    questo percorso con la serie Survival di Minecraft, che prosegue ancora
                                    oggi dopo oltre un decennio e 1.000 episodi. </p>
                                <p>
                                    Ho sempre cercato di offrire qualcosa di diverso e nel tempo ho
                                    sviluppato serie personalizzate che sono diventate appuntamenti fissi
                                    per il mio pubblico. Oltre a YouTube, mi sono cimentato anche con altre
                                    piattaforme come Twitch e TikTok, raggiungendo rispettivamente oltre
                                    180.000 e 115.000 follower.
                                </p>
                            </div>
                        </div>
                        <img src={eren2} alt={"Simone Caglioni"}/>
                    </div>
                    <div className={styles.erenblaze__section}>
                        <img src={eren3} alt={"Simone Caglioni"}/>
                        <div className={styles.erenblaze__content}>
                            <h1 className={styles.erenblaze__title}>OGGI</h1>
                            <div className={styles.erenblaze__paragraph}>
                                <p>Oggi ErenBlaze è sinonimo di contenuti di qualità nel panorama italiano
                                    del gaming, con un focus particolare su Minecraft, ma anche su altri
                                    titoli. Ogni settimana pubblico nuovi video sui miei tre canali,
                                    mantenendo sempre alta la qualità e la creatività dei contenuti. </p>
                                <p>
                                    Le mie serie, che spaziano da tutorial approfonditi a sfide e guide sui
                                    nuovi aggiornamenti di Minecraft, sono diventate dei veri e propri punti di
                                    riferimento per chi vuole restare aggiornato e divertirsi. Il mio
                                    impegno nel creare una community attiva e partecipativa mi ha
                                    permesso di ottenere ottimi risultati in termini di engagement.
                                </p>
                                <p className={styles.erenblaze__date}>29/09/2024</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={styles.erenblaze__phrase}>
                    <h1>&lt;&lt;</h1>
                    <p>Oggi, il mio obiettivo è continuare a crescere, migliorando la qualità dei contenuti e portando sempre più novità e collaborazioni ai miei Blazers.</p>
                    <h1>&gt;&gt;</h1>
                </div>
                <h1 className={styles.erenblaze__socialText}>I MIEI SOCIAL</h1>
                <div className={styles.social_youtube}>
                    <div className={styles.erenblaze__link} onClick={(e) => Redirects.send("https://youtube.com/erenblaze", e)}><img src={yt} alt={"youtube"}/>ERENBLAZE</div>
                    <div className={styles.erenblaze__link} onClick={(e) => Redirects.send("https://youtube.com/ezalbnere", e)}><img src={yt} alt={"youtube"}/>ERENBLAZE LIVE</div>
                    <div className={styles.erenblaze__link} onClick={(e) => Redirects.send("https://www.youtube.com/@erenblazexl", e)}><img src={yt} alt={"youtube"}/>ERENBLAZE XL</div>
                </div>
                <div className={styles.social_twitch}>
                    <div className={styles.erenblaze__link} onClick={(e) => Redirects.send("https://twitch.tv/erenblaze", e)}><img src={tw} alt={"twitch"}/>ERENBLAZE</div>
                </div>
                <div className={styles.social_others}>
                    <div className={styles.erenblaze__link} onClick={(e) => Redirects.send("https://instagram.com/erenblaze", e)}><img src={ig} alt={"instagrma"}/>ERENBLAZE</div>
                    <div className={styles.erenblaze__link} onClick={(e) => Redirects.send("https://tiktok.com/@erenblaze", e)}><img src={tt} alt={"tiktok"}/>ERENBLAZE</div>
                    <div className={styles.erenblaze__link} onClick={(e) => Redirects.send("https://discord.erenblaze.it", e)}><img src={ds} alt={"discord"}/>I KOHAI DI EREN</div>
                    <div className={styles.erenblaze__link} onClick={(e) => Redirects.send("https://t.me/newserenblaze", e)}><img src={tg} alt={"telegram"}/>ERENBLAZE NEWS</div>
                    <div className={styles.erenblaze__link} onClick={(e) => Redirects.send("https://www.amazon.it/shop/erenblaze", e)}><img src={am} alt={"amazon"}/>REFERREAL</div>
                </div>
                <div className={styles.erenblaze__email} onClick={(e) => Redirects.send("mailto:EREN@ARKADIA.AGENCY", e)}>
                    <img src={email} alt={"email"}/><span>EREN@ARKADIA.AGENCY</span>
                </div>
                <Footer/>
            </div>
        </>
    );

}

export default ErenBlaze;
